import { render, staticRenderFns } from "./supporting-asset.vue?vue&type=template&id=47b1cce2&scoped=true"
import script from "./supporting-asset.vue?vue&type=script&lang=ts"
export * from "./supporting-asset.vue?vue&type=script&lang=ts"
import style0 from "./supporting-asset.vue?vue&type=style&index=0&id=47b1cce2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1cce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b1cce2')) {
      api.createRecord('47b1cce2', component.options)
    } else {
      api.reload('47b1cce2', component.options)
    }
    module.hot.accept("./supporting-asset.vue?vue&type=template&id=47b1cce2&scoped=true", function () {
      api.rerender('47b1cce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supporting-asset/supporting-asset.vue"
export default component.exports